import { render, staticRenderFns } from "./RestaurantSwitcher.vue?vue&type=template&id=460870c0"
import script from "./RestaurantSwitcher.vue?vue&type=script&lang=ts"
export * from "./RestaurantSwitcher.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports